import 'whatwg-fetch'


const Office = window.Office;

export const insertAttachmentIntoDocument = function(attachment) {
  return new Promise(function(resolve, reject) {
    try {
      if (!Office.context) {
        return reject(
          new Error('Context does not exist. It appears you are executing outside of Office.')
        );
      }
      if (!Office.context.document) {
        return reject(
          new Error('Document does not exist. It appears you are executing outside of Office.')
        );
      }

      const coercionType = Office.CoercionType;
      if (coercionType.Image !== undefined) {
        return downloadFile(attachment.attributes.url)
          .then(blob => getBase64FromBlob(blob))
          .then(base64EncodedImageString => insertImage(base64EncodedImageString))
          .then(() => resolve())
          .catch(e => reject(e));
      } else if (coercionType.Html !== undefined) {
        const html = '<img src="' + attachment.attributes.url + '"/>';
        return insertHtml(html)
          .then(() => resolve())
          .catch(e => reject(e));
      } else {
        // console.log('Coercion type is not supported', coercionType);
        return reject(new Error('Image and Html CoercionType not supported'));
      }
    } catch (e) {
      reject(e);
    }
  });
};

const downloadFile = function(url) {
  console.log('Fetching downloadFile', url)

  var init = {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache'
  };

  var req = new Request(url, init);

  return window.fetch(req).then(function(response) {
    if(response.ok) {
      console.log('Got blob')
      return response.blob();
    }
    throw new Error('Network response was not ok.');
  })
  .catch(function(error) {
    console.log('There has been a problem with your fetch operation: ', error.message);
  });
};

const getBase64FromBlob = function(blob) {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        resolve(reader.result.split(',').pop());
      };
    } catch (e) {
      reject(e);
    }
  });
};

const insertImage = function(base64EncodedImageString) {
  return new Promise(function(resolve, reject) {
    Office.context.document.setSelectedDataAsync(
      base64EncodedImageString,
      {
        coercionType: Office.CoercionType.Image,
        imageLeft: 0,
        imageTop: 0
      },
      asyncResult => {
        if (asyncResult.status === Office.AsyncResultStatus.Failed) {
          return reject(
            new Error(`Inserting image failed with error: ${asyncResult.error.message}`)
          );
        }
        resolve();
      }
    );
  });
};

const insertHtml = function(html) {
  return new Promise(function(resolve, reject) {
    Office.context.document.setSelectedDataAsync(
      html,
      {
        coercionType: Office.CoercionType.Html
      },
      asyncResult => {
        if (asyncResult.status === Office.AsyncResultStatus.Failed) {
          return reject(
            new Error(`Inserting image failed with error: ${asyncResult.error.message}`)
          );
        }
        resolve();
      }
    );
  });
};



// WEBPACK FOOTER //
// ./src/services/document.js